import React, { Component } from 'react';

import mixpanel from "mixpanel-browser";
import SimplifiedLayout from "./SimplifiedLayout";

import Helmet from 'react-helmet';

import Plans from './Plans';

import './content/content.css';
import './PlansPage.css'

class PlansPage extends Component {

	constructor() {
		super();
		this.mixpanel = mixpanel;
	}

  render() {
    return (
    	<SimplifiedLayout>

    		<Helmet title="Plans &amp; Pricing for Webfinery Search" />
	      
    		<div className="plansContainer">
    			<Plans/>
    		</div>

	    </SimplifiedLayout>
    );
  }
}

export default PlansPage;



// WEBPACK FOOTER //
// ./src/PlansPage.js